import PropTypes from 'prop-types'
import React, { Component } from 'react'
import TextSelection from './TextSelection'
import Label from './Label'

export default class TranscriptSelection extends Component {
  static propTypes = {
    disabled: PropTypes.bool.isRequired,
    endTime: PropTypes.number.isRequired,
    onSelect: PropTypes.func.isRequired,
    startTime: PropTypes.number.isRequired,
    timestamps: PropTypes.arrayOf(PropTypes.number).isRequired,
    transcript: PropTypes.string.isRequired,
    transcriptType: PropTypes.string.isRequired
  }

  static defaultProps = {
    disabled: false,
    endTime: 0,
    startTime: 0,
    timestamps: [],
    transcript: '',
    transcriptType: ''
  }

  findTimeOfElement(element) {
    return parseFloat(element.parentElement.getAttribute('data'))
  }

  handleSelection = ({ startElement, endElement, collapsed, ...rest }) => {
    const { onSelect } = this.props
    const startTime = collapsed ? 0 : this.findTimeOfElement(startElement)
    const endTime = collapsed ? 0 : this.findTimeOfElement(endElement)
    onSelect({ startTime, endTime, collapsed, ...rest })
  }

  render() {
    const {
      disabled,
      endTime,
      startTime,
      timestamps,
      transcript,
      ...rest
    } = this.props

    if (disabled) {
      return <span>{transcript}</span>
    }

    return (
      <div>
        {this.props.transcriptType === 'machine' && transcript !== '' && (
          <Label
            type="default"
            text={I18n.t(
              "You're viewing a free machine transcription. You may edit it to improve accuracy."
            )}
            // Commenting out the original verbiage that includes requesting a human transcript, to be restored when a provider is re-added.
            // text={ I18n.t("You're viewing a free machine transcription. For greater accuracy, you can edit or request a human transcript.") }
          />
        )}
        <TextSelection
          {...rest}
          startTime={startTime}
          endTime={endTime}
          text={transcript}
          onSelect={this.handleSelection}
          snapToWords={true}
          timestamps={timestamps}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/TranscriptSelection.js